import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import HeroCards from "./components/HeroCards";
import ReviewsSection from "./components/ReviewsSection";
import HowItWorksSection from "./components/HowItWorksSection";
import GallerySection from "./components/GallerySection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import GuaranteeTerms from "./pages/GuaranteeTerms";
import Accessibility from "./pages/Accessibility";

const Home = () => {
  return (
    <div className="relative min-h-screen bg-white flex flex-col overflow-hidden">
      {/* Background hero image — desktop only (positioned for wide viewports) */}
      <img
        src="https://customer-assets.emergentagent.com/job_meinhaus-nav/artifacts/frw5xm1b_Screenshot%202026-04-28%20at%203.00.36%E2%80%AFPM.png"
        alt=""
        aria-hidden="true"
        className="hidden lg:block pointer-events-none select-none absolute"
        style={{
          right: "calc(50% - 600px)",
          top: "180px",
          width: "660px",
          maxWidth: "none",
          height: "auto",
          zIndex: 0,
        }}
      />

      <div className="relative z-10 flex-1 flex flex-col">
        <Navbar />

        {/* Above-the-fold content area */}
        <main className="flex-1 flex flex-col">
          <HeroSection />

          {/* spacer pushes cards to bottom */}
          <div className="flex-1" />

          {/* divider */}
          <div className="max-w-[1200px] w-full mx-auto px-4">
            <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />
          </div>

          {/* Cards anchored to bottom of viewport */}
          <HeroCards />
        </main>

        {/* Reviews section continues the grey-to-white gradient below */}
        <ReviewsSection />

        {/* How It Works — editorial blueprint timeline */}
        <HowItWorksSection />

        {/* Project Gallery — before/after */}
        <GallerySection />

        {/* FAQ */}
        <FAQSection />

        {/* Final CTA */}
        <FinalCTASection />

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/guarantee" element={<GuaranteeTerms />} />
          <Route path="/accessibility" element={<Accessibility />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
